import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import HelpIcon from "@mui/icons-material/Help";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsIcon from "@mui/icons-material/Settings";

function getMenu(props = {}) {

    const {appContext} = props;
    const {menus, routes, /*userStatusManager*/} = appContext;

    return [
        {
            name: menus.loginMenu,
            href: "/login",
            role: function (p) {
                return !(p.user?._id);
            },
            Icon: AccountCircleIcon
        },
        {
            name: menus.signupMenu,
            href: "/signup",
            role: function (p) {
                return !(p.user?._id);
            },
            Icon: PersonAddIcon
        },
        {
            name: menus.accountSettingsMenu,
            href: function () {
                return routes.accountRoute
            },
            role: function (p) {
                if (!p.page){return false;}
                return p.user?._id && p.user._status_isNotDeleted;
            },
            Icon: SettingsIcon,
            disableParentRoute: true
        },
        {
            name: menus.changeData, href: "/changedata",
            role: function (p) {
                return p.user?._id && p.user._status_isNotDeleted;
            },
            Icon: PersonIcon
        },
        {
            name: menus.changeEmail, href: "/changeemail",
            role: function (p) {
                return p.user?._id && p.user._status_isNotDeleted;
            },
            Icon: EmailIcon
        },
        {
            name: menus.emailConfirmation, href: "/emailconfirmation",
            role: function (p) {
                return p.user?._id && !p.user?.emailConfirmed && p.user._status_isNotDeleted;
            },
            Icon: CheckCircleIcon
        },
        {
            name: menus.changePassword, href: "/changepassword",
            role: function (p) {
                return p.user?._id && p.user._status_isNotDeleted;
            },
            Icon: LockIcon
        },
        {
            name: menus.forgotPasswordMenu, href: "/forgotpassword",
            role: function (p) {
                return (p.user && p.user._status_isNotDeleted) || !(p.user?._id)
            },
            Icon: HelpIcon,
        },
        {
            name: menus.deleteAccount, href: "/deleteaccount",
            role: function (p) {
                return p.user?._id && p.user._status_isNotDeleted;
            },
            Icon: DeleteIcon
        },
        {
            name: menus.logoutMenu, href: "/logout",
            role: function (p) {
                return p.user?._id;
            },
            Icon: ExitToAppIcon
        },
    ];

}
export default getMenu;
